import { motion } from 'framer-motion';

interface LogoProps {
  size?: number;
  showTagline?: boolean;
  animated?: boolean;
}

export default function Logo({ size = 52, showTagline = false, animated = false }: LogoProps) {
  if (animated) {

    return (
      <motion.div
        className="flex flex-col items-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.img
          src="/logo/debtnet-animated.png"
          alt="DebtNet logo"
          style={{ height: size * 4, width: "auto" }}
          className="select-none"
          initial={{ y: -20, opacity: 0 }}
          animate={{ 
            y: [0, -10, 0],
            opacity: 1,
          }}
          transition={{
            y: {
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut"
            },
            opacity: {
              duration: 0.6
            }
          }}
        />
        {showTagline && (
          <motion.p
            className="text-sm text-brand-gold uppercase tracking-widest mt-6"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            Where debt data becomes intelligence
          </motion.p>
        )}
      </motion.div>
    );
  }

  return (
    <div className="flex flex-col items-start">
      <img
        src="/logo/debtnet-static.png"
        alt="DebtNet logo"
        style={{ height: size, width: "auto" }}
        className="select-none"
      />
      {showTagline && (
        <p className="text-xs text-brand-gold uppercase tracking-widest mt-1">
          Where debt data becomes intelligence
        </p>
      )}
    </div>
  );
}
